import React from 'react'
import { Box, Button, IconButton, Popper } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { isMobileView } from '@sis/react-library';

interface PagelInformationProps {
    heading: string;
    pageInfo: React.ReactNode;
    wrapRightElementForMobile?: boolean;
}

export const PagelInformation = ({
    heading, pageInfo, wrapRightElementForMobile
}: PagelInformationProps) => {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);

    const isMobile = isMobileView();

    const padding = isMobile ?
        (wrapRightElementForMobile === false ? '12px 4px' : '0 0 10px 0') :
        '12px 4px'

    return (
        <Box
            sx={{ padding }}
        >
            <Button
                variant="contained"
                color="secondary"
                onClick={handleClick}
            >
                Info
            </Button>
            <Popper open={open} anchorEl={anchorEl} sx={{zIndex: 9999}}>
                <Box
                    sx={{
                        border: '1px solid black',
                        borderRadius: '4px',
                        marginTop: '10px',
                        padding: '10px',
                        paddingTop: 0,
                        background: 'rgb(225, 255, 225)',
                        width: '800px',
                        maxWidth: 'calc(100vw - 30px)',
                        maxHeight: 'calc(100vh - 150px)',
                        overflow: 'auto',
                        position: 'relative'                        
                    }}
                >
                    <h4>{heading}</h4>
                    {pageInfo}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0
                        }}
                    >
                        <IconButton onClick={() => setAnchorEl(null)}>
                            <CancelIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Popper>
        </Box>
    )
}
